// extracted by mini-css-extract-plugin
export default {"formInput":"styles_formInput__325xK","NEWloginElement":"styles_NEWloginElement__4m5Wh","showPass":"styles_showPass__gqKHS","formInputDark":"styles_formInputDark__3Y0Cx"};